<template>
  <div
    class="container w-full flex justify-between items-center md:pb-32 md:pt-20 pb-9 pt-5 max-md:flex-col max-md:gap-10"
  >
    <div
      class="md:w-1/3 flex flex-col md:gap-8 gap-2.5 max-md:order-2 max-md:items-center max-md:text-center"
    >
      <span class="md:text-heading-3 text-mobile-heading-3 text-title-color">
        Oops! The page you're looking for doesn't exist.
      </span>
      <span
        class="md:text-paragraph-2 text-mobile-paragraph-2 text-paragraph-color"
      >
        We're sorry, but the page you were trying to reach cannot be found. It
        might have been removed, had its name changed, or is temporarily
        unavailable.
      </span>
      <BaseButton
        @click="router.push(localePath('/'))"
        type="outlined"
        class="!w-fit text-[14px] md:mt-5 mt-2.5"
        :label="t('homePage')"
      />
    </div>
    <NuxtImg
      loading="lazy"
      src="https://tw028jd0.turpal.com/assets/404-error.svg"
      alt="404 - Page not found"
      class="md:w-[420px] w-[420px]"
    />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
const router = useRouter();
const localePath = useLocalePath();
</script>
